import { configureStore, compose, applyMiddleware } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import logger from "redux-logger";
// import thunkMiddleware from "redux-thunk";
import { rootReducer } from "./rootReducer";
import { encryptTransform } from 'redux-persist-transform-encrypt';

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user", "auth"],
};

// const persistedReducer = persistReducer(persistConfig, rootReducer);
const persistedReducer = persistReducer(
  
  {
    ...persistConfig,
    transforms: [
      encryptTransform({
        secretKey: process.env.REACT_APP_SK,
        onError: function (error:any) {
          // Handle the error.
        },
      }),
    ],
  },
  rootReducer
);
// const middlewares =
//   process.env.MODE_ENV === "development"
//     ? [logger, thunkMiddleware]
//     : [thunkMiddleware];
// const middlewareEnhancer = applyMiddleware(...middlewares);
const middlewareEnhancer = applyMiddleware( logger)
const enhancers = [middlewareEnhancer];
const composedEnhancers =
  (process.env.MODE_ENV !== "production" &&
    typeof window !== "undefined" &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose(...enhancers);
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      enhancers: composedEnhancers,
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
export const persistor = persistStore(store);
export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
